import { render, staticRenderFns } from "./gallerySales.vue?vue&type=template&id=6ff55d94&scoped=true"
import script from "./gallerySales.vue?vue&type=script&lang=js"
export * from "./gallerySales.vue?vue&type=script&lang=js"
import style0 from "./gallerySales.vue?vue&type=style&index=0&id=6ff55d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff55d94",
  null
  
)

export default component.exports